import React, { useEffect, useState } from "react";
import { useJoinNowContext } from "../../Context/joinNowContext";
import { Box, InputAdornment, TextField } from "@mui/material";
import CrossSvg from "../../svg/crossSvg";
import axios from "axios";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
function OtpVerfication() {
  const {
    email,
    otp,
    setOtp,
    emergencyName,
    setEmergencyName,
    emergencyPhone,
    setEmergencyPhoneNumber,
    month,
    step,
    setStep,
    first_name,
    last_name,
    gender,
    dob,
    identity,
    membershipId,
    phone_no,
    selectedPlan,
  } = useJoinNowContext();
  const [terrCondition, setTermCondition] = useState(false);
  const [uptodate, setUptodate] = useState(false);
  const [timeLeft, setTimeLeft] = useState(120); // Timer state (2 minutes = 120 seconds)
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    otp: "",
    emergencyName: "",
    emergencyPhoneNumber: "",
  });
  const atIndex = email.indexOf("@"); // Find the index of the "@" symbol

  // Get the first two characters before the "@"
  const beforeAt = email.slice(Math.max(0, atIndex - 4), atIndex);

  // Get the portion after the "@"
  const afterAt = email.slice(atIndex);

  // Combine the results
  const formattedEmail = beforeAt + afterAt;

  const Submit = async (data) => {
    // const userDetails = {
    //   first_name: first_name,
    //   last_name: last_name,
    //   email: email,
    //   phone_no: phone_no,
    //   identity: identity,
    //   dob: dob,
    //   gender: gender,
    //   membershipId: membershipId,
    //   emergencyName: emergencyName,
    //   emergencyPhone: emergencyPhone,
    //   month: month,
    // };
    // axios
    //   .post("https://portal.fitstreak.club/api/api/temp-user", userDetails)
    //   .then((secondResponse) => {
    //     console.log(
    //       "User details successfully submitted:",
    //       secondResponse.data
    //     );
    //     // You can proceed to the next step here
    //     // setStep(step + 1);
    //   })
    //   .catch((secondError) => {
    //     console.error("Error submitting user details:", secondError.message);
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       submit: "Failed to submit user details", // Error message for the second API
    //     }));
    //   });
    // First API call to verify OTP
    setLoading(true);
    const record = {
      email: email,
      otp: otp,
    };
    try {
      await axios
        .post("https://portal.fitstreak.club/api/api/temp-user/verify_otp", {
          data: record,
        })
        .then((response) => {
          if (response.data.status === "success") {
            // Second API call to submit user details
            const userDetails = {
              first_name: first_name,
              last_name: last_name,
              email: email,
              phone_no: phone_no,
              identity: identity,
              dob: dob,
              gender: gender,
              membershipId: membershipId,
              emergencyName: emergencyName,
              emergencyPhone: emergencyPhone,
              month: month,
            };

            axios
              .post(
                "https://portal.fitstreak.club/api/api/temp-user",
                userDetails
              )
              .then((secondResponse) => {
                // You can proceed to the next step here
                setStep(step + 1);
              })
              .catch((secondError) => {
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  submit: "Failed to submit user details", // Error message for the second API
                }));
              });
          } else {
            setErrors((prevErrors) => ({
              ...prevErrors,
              otp: "OTP verification failed", // Error message if OTP is not verified
            }));
          }
        })
        .catch((error) => {
          console.error("Error verifying OTP:", error.message);
          setErrors((prevErrors) => ({
            ...prevErrors,
            otp: "OTP verification failed due to network error", // Network or API error
          }));
        });
    } catch (error) {
      console.log("this is error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "Otp") {
      if (value === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          otp: "otp is required",
        }));
      } else if (value.length < 6) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          otp: "otp must have 6 number",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          otp: "",
        }));
      }
      setOtp(value.slice(0, 6));
    }

    if (name === "phoneNumber") {
      const phoneRegex = /^\d+$/;
      if (!phoneRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          emergencyPhoneNumber: "invalid number",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          emergencyPhoneNumber: "",
        }));
      }
      setEmergencyPhoneNumber(value);
    }

    if (name === "EmergencyName") {
      if (/\d/.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          emergencyName: "Please enter a valid name (no numbers allowed).",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          emergencyName: "",
        }));
      }
      setEmergencyName(value);
    }
  };
  const isButtonDisabled = Object.values(errors).some((error) => error !== "");
  const handleClearField = (field: string) => {
    if (field === "Otp") {
      setOtp("");
      setErrors((prevErrors) => ({
        ...prevErrors,
        otp: "",
      }));
    }
    if (field === "EmergencyName") {
      setEmergencyName("");
      setErrors((prevErrors) => ({
        ...prevErrors,
        emergencyName: "",
      }));
    }
    if (field === "phoneNumber") {
      setEmergencyPhoneNumber("");
      setErrors((prevErrors) => ({
        ...prevErrors,
        phoneNumber: "",
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };
  useEffect(() => {
    if (!isTimerActive) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer); // Stop the timer when it reaches 0
          setIsTimerActive(false); // Deactivate the timer
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000); // Update every second

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [isTimerActive]);

  // Format time in MM:SS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const handleResendClick = async () => {
    setLoading(true);
    const data = {
      email: email,
      first_name: first_name,
      last_name: last_name,
    };

    try {
      await axios
        .post("https://portal.fitstreak.club/api/api/temp-user/sendOtp", {
          data: data,
        })
        .then((response) => {
          toast.success("Otp Sent");
          console.log("this is response", response.data, email);
        })
        .catch((error) => {
          // Show error if API call fails
          console.log("this is error ", error.message);
          console.error(
            "API Error:",
            error.response?.data?.message || "Something went wrong"
          );
          toast.error("An error occured");
        });
      setIsTimerActive(true); // Restart the timer
      setTimeLeft(120); // Reset the timer to 2 minutes
      setOtp(""); // Optionally reset OTP field}
    } catch (error) {
      console.log("this is error ", error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="step1 w-[95%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[600px] rounded-[4px] bg-[#303030] m-auto item-center justify-center">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10">
          <CircularProgress size="3rem" style={{ color: "red" }} />
        </div>
      )}
      <h1 className="lg:text-lg text-left text-base text-white w-full mb-2">
        OTP Vefication
      </h1>
      <p className="text-[#bbbbbb] md:text-sm text-xs text-left ">
        We sent an OTP to you email ending in ***{formattedEmail} Please enter
        the code you received below.
      </p>
      <Box
        component="form"
        sx={{ "& > :not(style)": { m: 1, width: "100%" } }}
        noValidate
        autoComplete="on"
      >
        <TextField
          id="Otp"
          name="Otp"
          label="Otp"
          variant="standard"
          value={otp}
          onChange={handleChange}
          error={!!errors.otp}
          helperText={errors.otp}
          InputProps={{
            endAdornment: errors.otp ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("Otp")} />{" "}
                {/* Conditionally render CrossSvg */}
              </InputAdornment>
            ) : null,
          }}
        />
        <div style={{ color: "red", marginTop: "8px", textAlign: "left" }}>
          {isTimerActive ? (
            `Time Left: ${formatTime(timeLeft)}`
          ) : (
            <button
              onClick={handleResendClick}
              className="w-[120px] m-0 p-1 bg-red text-white mt-4 rounded-[5px]"
              disabled={isTimerActive || loading === true} // Make the button inactive when timer is running
            >
              Resend OTP
            </button>
          )}
        </div>
      </Box>
      <h1 className="lg:text-lg text-left text-base text-white w-full mb-2 mt-4">
        Emergency Contact Info{" "}
        <span className="ml-2 lg:text-sm text-xs text-[#bbbbbb]">
          {"(Just In Case)"}
        </span>
      </h1>
      <Box
        component="form"
        sx={{ "& > :not(style)": { m: 1, width: "100%" } }}
        noValidate
        autoComplete="on"
      >
        <TextField
          id="EmergencyName"
          name="EmergencyName"
          label="Name"
          variant="standard"
          value={emergencyName}
          onChange={handleChange}
          error={!!errors.emergencyName}
          helperText={errors.emergencyName}
          InputProps={{
            endAdornment: errors.emergencyName ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("EmergencyName")} />{" "}
                {/* Conditionally render CrossSvg */}
              </InputAdornment>
            ) : (
              <span className="bg-none px-3 py-1 otem-center rounded-[6px] text-white text-xs ">
                {"(optional)"}{" "}
              </span>
            ),
          }}
        />
        <TextField
          id="phoneNumber"
          name="phoneNumber"
          label="Phone Number"
          variant="standard"
          value={emergencyPhone}
          onChange={handleChange}
          error={!!errors.emergencyPhoneNumber}
          helperText={errors.emergencyPhoneNumber}
          InputProps={{
            endAdornment: errors.emergencyPhoneNumber ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("phoneNumber")} />{" "}
                {/* Conditionally render CrossSvg */}
              </InputAdornment>
            ) : (
              <span className="bg-none px-3 py-1 otem-center rounded-[6px] text-white text-xs ">
                {"(optional)"}{" "}
              </span>
            ),
          }}
        />
      </Box>
      <label className="flex items-center mb-4 cursor-pointer mt-6">
        <input
          type="radio"
          name="gender"
          value="I agree to Fit Streak's Terms & Conditions."
          checked={terrCondition === true}
          onClick={() => setTermCondition(!terrCondition)}
          className={`hidden peer "}`}
        />
        <span
          className={`w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 ${
            terrCondition === true
              ? "border border-red bg-red"
              : "border-2 border-gray-400 ng-inherite"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-3 h-3 text-white ${
              terrCondition === true ? "block" : "hidden"
            } transition-opacity duration-200`}
            viewBox="0 0 20 20"
            style={{ fill: "#fff" }}
          >
            <g data-name="Group 24954">
              <path
                data-name="Path 68503"
                d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                transform="translate(-4.373 -3.52)"
              />
            </g>
          </svg>
        </span>
        <span
          className={`ml-5 ${
            terrCondition === true ? "text-white" : "text-[#bbbbbb]  "
          } text-left md:text-sm text-xs `}
        >
          I agree to Fit Streak's Terms & Conditions.
        </span>
      </label>

      {/* Radio Button: Female */}
      <label className="flex items-center mb-4 cursor-pointer">
        <input
          type="radio"
          name="gender"
          value="Female"
          checked={uptodate === true}
          onClick={() => setUptodate(!uptodate)}
          className={`hidden peer ${
            uptodate === true ? "text-white" : "text-[#bbbbbb]"
          }`}
        />
        <span
          className={`w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 ${
            uptodate === true
              ? "border border-red bg-red"
              : "border-2 border-gray-400 ng-inherite"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-3 h-3 text-white ${
              uptodate === true ? "block" : "hidden"
            } transition-opacity duration-200`}
            viewBox="0 0 20 20"
            style={{ fill: "#fff" }}
          >
            <g data-name="Group 24954">
              <path
                data-name="Path 68503"
                d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                transform="translate(-4.373 -3.52)"
              />
            </g>
          </svg>
        </span>
        <span
          className={`ml-5 ${
            uptodate === true ? "text-white" : "text-[#bbbbbb]  "
          } text-left md:text-sm text-xs `}
        >
          {"Keep me up-to-date with important updates and news (optional) "}
        </span>
      </label>
      <div className="flex w-full  h-auto   justify-end   ">
        <button
          className={`${
            otp == "" || terrCondition === false || isButtonDisabled
              ? "bg-inherite border border-[#4e4e4e]"
              : "bg-red"
          }  py-2 px-6 xxs:text-sm   w-max rounded-[5px] text-white font-bold text-base mt-10`}
          disabled={otp == "" || terrCondition === false || isButtonDisabled}
          onClick={Submit}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default OtpVerfication;
